import { Id, toast, type ToastOptions, ToastType } from 'vue3-toastify'
import Toast from '@components/ui/Toast.vue'

export const useToast = () => {
  const showToast = ({
    type = 'info',
    text,
    options = {}
  }: {
    type: ToastType
    text: string
    options?: ToastOptions
  }) => {
    return toast(Toast, {
      containerId: 'adk-toasts',
      ...options,
      data: {
        message: text
      },
      type
    })
  }

  const removeToast = (toastId: Id) => {
    toast.remove(toastId)
  }

  const clearToasts = () => {
    toast.remove()
  }

  return {
    showToast,
    removeToast,
    clearToasts
  }
}
